// export const BASE_URL = "http://localhost:8001";
export const BASE_URL = "https://api.tiolocoo.com";

export const Roles = {
  ADMIN: "administrador",
  MODERADOR: "moderador",
};
